import React from 'react';

import { Grid, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { CostIssuingRulesList } from '../../features/costIssuingRules/components/CostIssuingRulesList';

export const CostIssuingRulesListPage = (): JSX.Element => {
	return (
		<Layout>
			<Grid container paddingY={5} justifyContent={'center'}>
				<Grid item xs={12} sx={{ ml: 20 }}>
					<Typography variant="h4" style={{ fontWeight: 500 }}>
						Costos de emisión
					</Typography>
				</Grid>
				<Grid paddingY={5}>
					<CostIssuingRulesList />
				</Grid>
			</Grid>
		</Layout>
	);
};
